import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { buttonBaseClasses, inputAdornmentClasses } from "@mui/material";

export const input = [
  css`
    width: 100%;
    height: 37px;
  `,
  css({
    [`& .${inputAdornmentClasses.root}`]: {
      margin: 0,
      fontSize: 15,
      padding: 0,
      width: 34,
      height: "100%",
      maxHeight: "unset",
    },
    [`& .${buttonBaseClasses.root}`]: {
      margin: 0,
      fontSize: "unset",
    },
  }),
];

export const container = css`
  position: relative;
  display: inline-block;
  min-width: 60px;
`;

export const root = css`
  position: relative;
`;

export const error = (theme: ExactTheme) => css`
  color: ${theme.colorsV2.danger.bg};
  font-size: 12px;
  line-height: 18px;
  font-style: normal;
  font-weight: 400;
  position: absolute;
  top: 100%;
`;
